import GasLoginLogo from './LoginLogo.svg'

export const LoginGasLogo = GasLoginLogo
